(function() {
  'use strict';

  angular.module('component.drafts', []);
})();
